var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98321 3.45468C8.54595 3.45035 9.00117 3.90377 9 4.4677C8.99868 5.03148 8.54149 5.49202 7.97882 5.49642L5.51097 5.51367L5.49376 7.9888C5.48914 8.54789 5.02953 9.00064 4.4673 8.99998C3.90492 8.99925 3.453 8.54524 3.45761 7.98601L3.47468 5.52798L1.01672 5.54522C0.454122 5.54962 -0.00116967 5.09613 2.25733e-06 4.53227C0.00132067 3.96849 0.45859 3.50795 1.02126 3.50362L3.48904 3.4863L3.50632 1.01117C3.51101 0.452084 3.97055 -0.000674964 4.53278 -1.45372e-05C5.09516 0.000645889 5.54708 0.454726 5.54239 1.01396L5.52532 3.47199L7.98321 3.45468Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.14600aab1923242ef9950b0ea9a698b8.svg";
export { ForwardRef as ReactComponent };